import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enNav from "../locales/en/nav.json";
import enAccount from "../locales/en/account.json";
import enDashboard from "../locales/en/dashboard.json";
import enTargets from "../locales/en/targets.json";
import enProfiles from "../locales/en/profiles.json";
import enUserManagement from "../locales/en/userManagement.json";
import enGenerate from "../locales/en/generate.json";
import enExampleTrainingPrompts from "../locales/en/exampleTrainingPrompts.json";
import enRunTestsModal from "../locales/en/runTestsModal.json";
import enScheduleTestModal from "../locales/en/scheduleTestModal.json";
import enAttackSurfaceTestsStatusPage from "../locales/en/attackSurfaceTestsStatusPage.json";
import enSimpleScanProgressModal from "../locales/en/simpleScanProgressModal.json";
import enQuickStart from "../locales/en/quickStart.json";
import enCategoryLabels from "../locales/en/categoryLabels.json";
import enLevelDisplayNames from "../locales/en/levelDisplayNames.json";
import enAiDosRecs from "../locales/en/reports_recs/recs/AiDosRecs.json";
import enAiModelRecs from "../locales/en/reports_recs/recs/AiModelRecs.json";
import enMcpRecs from "../locales/en/reports_recs/recs/McpRecs.json";
import enPromptsDocsRecs from "../locales/en/reports_recs/recs/PromptsDocsRecs.json";
import enRegCompRecs from "../locales/en/reports_recs/recs/RegCompRecs.json";
import enRtoRecs from "../locales/en/reports_recs/recs/RtoRecs.json";
import enAiDosDetailed from "../locales/en/reports_recs/reports_detailed/AiDosReport.json";
import enAiModelDetailed from "../locales/en/reports_recs/reports_detailed/AiModelReport.json";
import enMcpDetailed from "../locales/en/reports_recs/reports_detailed/McpReport.json";
import enPromptsDocsDetailed from "../locales/en/reports_recs/reports_detailed/PromptsDocsReport.json";
import enRegCompDetailed from "../locales/en/reports_recs/reports_detailed/RegCompReport.json";
import enRtoDetailed from "../locales/en/reports_recs/reports_detailed/RtoReport.json";
import enReportsCommon from "../locales/en/reports_recs/reports_common.json";
import enReportsPage from "../locales/en/reports_recs/reports_page.json";
import enHelp from "./help/en";

import frNav from "../locales/fr/nav.json";
import frAccount from "../locales/fr/account.json";
import frDashboard from "../locales/fr/dashboard.json";
import frTargets from "../locales/fr/targets.json";
import frProfiles from "../locales/fr/profiles.json";
import frUserManagement from "../locales/fr/userManagement.json";
import frGenerate from "../locales/fr/generate.json";
import frExampleTrainingPrompts from "../locales/fr/exampleTrainingPrompts.json";
import frRunTestsModal from "../locales/fr/runTestsModal.json";
import frScheduleTestModal from "../locales/fr/scheduleTestModal.json";
import frAttackSurfaceTestsStatusPage from "../locales/fr/attackSurfaceTestsStatusPage.json";
import frSimpleScanProgressModal from "../locales/fr/simpleScanProgressModal.json";
import frQuickStart from "../locales/fr/quickStart.json";
import frCategoryLabels from "../locales/fr/categoryLabels.json";
import frLevelDisplayNames from "../locales/fr/levelDisplayNames.json";
import frAiDosRecs from "../locales/fr/reports_recs/recs/AiDosRecs.json";
import frAiModelRecs from "../locales/fr/reports_recs/recs/AiModelRecs.json";
import frMcpRecs from "../locales/fr/reports_recs/recs/McpRecs.json";
import frPromptsDocsRecs from "../locales/fr/reports_recs/recs/PromptsDocsRecs.json";
import frRegCompRecs from "../locales/fr/reports_recs/recs/RegCompRecs.json";
import frRtoRecs from "../locales/fr/reports_recs/recs/RtoRecs.json";
import frAiDosDetailed from "../locales/fr/reports_recs/reports_detailed/AiDosReport.json";
import frAiModelDetailed from "../locales/fr/reports_recs/reports_detailed/AiModelReport.json";
import frMcpDetailed from "../locales/fr/reports_recs/reports_detailed/McpReport.json";
import frPromptsDocsDetailed from "../locales/fr/reports_recs/reports_detailed/PromptsDocsReport.json";
import frRegCompDetailed from "../locales/fr/reports_recs/reports_detailed/RegCompReport.json";
import frRtoDetailed from "../locales/fr/reports_recs/reports_detailed/RtoReport.json";
import frReportsCommon from "../locales/fr/reports_recs/reports_common.json";
import frReportsPage from "../locales/fr/reports_recs/reports_page.json";
import frHelp from "./help/fr";

import esNav from "../locales/es/nav.json";
import esAccount from "../locales/es/account.json";
import esDashboard from "../locales/es/dashboard.json";
import esTargets from "../locales/es/targets.json";
import esProfiles from "../locales/es/profiles.json";
import esUserManagement from "../locales/es/userManagement.json";
import esGenerate from "../locales/es/generate.json";
import esExampleTrainingPrompts from "../locales/es/exampleTrainingPrompts.json";
import esRunTestsModal from "../locales/es/runTestsModal.json";
import esScheduleTestModal from "../locales/es/scheduleTestModal.json";
import esAttackSurfaceTestsStatusPage from "../locales/es/attackSurfaceTestsStatusPage.json";
import esSimpleScanProgressModal from "../locales/es/simpleScanProgressModal.json";
import esQuickStart from "../locales/es/quickStart.json";
import esCategoryLabels from "../locales/es/categoryLabels.json";
import esLevelDisplayNames from "../locales/es/levelDisplayNames.json";
import esAiDosRecs from "../locales/es/reports_recs/recs/AiDosRecs.json";
import esAiModelRecs from "../locales/es/reports_recs/recs/AiModelRecs.json";
import esMcpRecs from "../locales/es/reports_recs/recs/McpRecs.json";
import esPromptsDocsRecs from "../locales/es/reports_recs/recs/PromptsDocsRecs.json";
import esRegCompRecs from "../locales/es/reports_recs/recs/RegCompRecs.json";
import esRtoRecs from "../locales/es/reports_recs/recs/RtoRecs.json";
import esAiDosDetailed from "../locales/es/reports_recs/reports_detailed/AiDosReport.json";
import esAiModelDetailed from "../locales/es/reports_recs/reports_detailed/AiModelReport.json";
import esMcpDetailed from "../locales/es/reports_recs/reports_detailed/McpReport.json";
import esPromptsDocsDetailed from "../locales/es/reports_recs/reports_detailed/PromptsDocsReport.json";
import esRegCompDetailed from "../locales/es/reports_recs/reports_detailed/RegCompReport.json";
import esRtoDetailed from "../locales/es/reports_recs/reports_detailed/RtoReport.json";
import esReportsCommon from "../locales/es/reports_recs/reports_common.json";
import esReportsPage from "../locales/es/reports_recs/reports_page.json";
import esHelp from "./help/es";

const LANGUAGE_STORAGE_KEY = "language";

const namespaces = [
  "nav",
  "account",
  "dashboard",
  "targets",
  "profiles",
  "userManagement",
  "generate",
  "exampleTrainingPrompts",
  "runTestsModal",
  "scheduleTestModal",
  "attackSurfaceTestsStatusPage",
  "simpleScanProgressModal",
  "help",
  "quickStart",
  "categoryLabels",
  "levelDisplayNames",
  "reports_recs",
];


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        help: enHelp,
        nav: enNav,
        account: enAccount,
        dashboard: enDashboard,
        targets: enTargets,
        profiles: enProfiles,
        userManagement: enUserManagement,
        generate: enGenerate,
        exampleTrainingPrompts: enExampleTrainingPrompts,
        runTestsModal: enRunTestsModal,
        scheduleTestModal: enScheduleTestModal,
        attackSurfaceTestsStatusPage: enAttackSurfaceTestsStatusPage,
        simpleScanProgressModal: enSimpleScanProgressModal,
        quickStart: enQuickStart,
        categoryLabels: enCategoryLabels,
        levelDisplayNames: enLevelDisplayNames,
        reports_recs: {
          recs: {
            aiDos: enAiDosRecs,
            aiModel: enAiModelRecs,
            mcp: enMcpRecs,
            promptsDocs: enPromptsDocsRecs,
            regComp: enRegCompRecs,
            rto: enRtoRecs,
          },
          reports_detailed: {
            aiDos: enAiDosDetailed,
            aiModel: enAiModelDetailed,
            mcp: enMcpDetailed,
            promptsDocs: enPromptsDocsDetailed,
            regComp: enRegCompDetailed,
            rto: enRtoDetailed,
          },
          reports_common: enReportsCommon,
          reports_page: enReportsPage,
        }
      },
      fr: {
        help: frHelp,
        nav: frNav,
        account: frAccount,
        dashboard: frDashboard,
        targets: frTargets,
        profiles: frProfiles,
        userManagement: frUserManagement,
        generate: frGenerate,
        exampleTrainingPrompts: frExampleTrainingPrompts,
        runTestsModal: frRunTestsModal,
        scheduleTestModal: frScheduleTestModal,
        attackSurfaceTestsStatusPage: frAttackSurfaceTestsStatusPage,
        simpleScanProgressModal: frSimpleScanProgressModal,
        quickStart: frQuickStart,
        categoryLabels: frCategoryLabels,
        levelDisplayNames: frLevelDisplayNames,
        reports_recs: {
          recs: {
            aiDos: frAiDosRecs,
            aiModel: frAiModelRecs,
            mcp: frMcpRecs,
            promptsDocs: frPromptsDocsRecs,
            regComp: frRegCompRecs,
            rto: frRtoRecs,
          },
          reports_detailed: {
            aiDos: frAiDosDetailed,
            aiModel: frAiModelDetailed,
            mcp: frMcpDetailed,
            promptsDocs: frPromptsDocsDetailed,
            regComp: frRegCompDetailed,
            rto: frRtoDetailed,
          },
          reports_common: frReportsCommon,
          reports_page: frReportsPage,
        }
      },
      es: {
        help: esHelp,
        nav: esNav,
        account: esAccount,
        dashboard: esDashboard,
        targets: esTargets,
        profiles: esProfiles,
        userManagement: esUserManagement,
        generate: esGenerate,
        exampleTrainingPrompts: esExampleTrainingPrompts,
        runTestsModal: esRunTestsModal,
        scheduleTestModal: esScheduleTestModal,
        attackSurfaceTestsStatusPage: esAttackSurfaceTestsStatusPage,
        simpleScanProgressModal: esSimpleScanProgressModal,
        quickStart: esQuickStart,
        categoryLabels: esCategoryLabels,
        levelDisplayNames: esLevelDisplayNames,
        reports_recs: {
          recs: {
            aiDos: esAiDosRecs,
            aiModel: esAiModelRecs,
            mcp: esMcpRecs,
            promptsDocs: esPromptsDocsRecs,
            regComp: esRegCompRecs,
            rto: esRtoRecs,
          },
          reports_detailed: {
            aiDos: esAiDosDetailed,
            aiModel: esAiModelDetailed,
            mcp: esMcpDetailed,
            promptsDocs: esPromptsDocsDetailed,
            regComp: esRegCompDetailed,
            rto: esRtoDetailed,
          },
          reports_common: esReportsCommon,
          reports_page: esReportsPage,
        }
      },
    },

    ns: namespaces,
    defaultNS: "common",
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "es"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    react: {
      useSuspense: false,
    },
  });

const applyDocumentLang = (lng) => {
  document.documentElement.lang = lng || "en";
};

applyDocumentLang(i18n.resolvedLanguage);
i18n.on("languageChanged", applyDocumentLang);

export default i18n;
export { LANGUAGE_STORAGE_KEY };
